import React from 'react';
import { Col, Container, Row, Button, Spinner } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import ADACheckbox from '../ADACheckbox';
import { Link } from 'react-router-dom';

class Billing extends ChemComponent {
	constructor(props) {
		super(props);
		
		var initBillingList = this.copyTable(billingList);
		initBillingList.query.order = ['JOB_ID desc','JOB_DATE'];

		this.state = {
			shop: {
				SHOP_ID: null,
				ORDER_BY: this.copyObject(initBillingList.query.order)
			},
			readyToBill: null,
			billingList: initBillingList,
			searchCount: null,
			renderKey: 0
		}
	}
	
	onSearchResult(data) {
		var readyToBill = {};
		for (var i = 0; i < data.Data.length; i++) {
			readyToBill['r' + data.Data[i].LINE_ID] = data.Data[i].READY_TO_BILL;
		}
		this.mergeState({
			readyToBill: readyToBill,
			searchCount: data.ResultCount,
		});
	}
	
	getReadyToBill(lineId) {
		return this.state.readyToBill && this.state.readyToBill['r' + lineId];
	}
	
	setReadyToBill(lineId, lineReadyToBill) {
		var readyToBill = this.copyObject(this.state.readyToBill);
		readyToBill['r' + lineId] = lineReadyToBill;
		this.mergeState({ readyToBill: readyToBill });
	}

	onChange(accessor, value) {
		var shop = this.copyObject(this.state.shop);
		this.setByAccessor(shop, accessor, value);
		this.mergeState({ shop: shop });
	}
	
	onSubmit(newOrder) {
		var newState = this.copyObject(this.state);
		newState.billingList = this.copyTable(billingList);
		newState.searchCount = null;
		newState.renderKey = this.state.renderKey + 1;
		if (newOrder) {
			newState.shop.ORDER_BY = this.copyObject(newOrder);
			newState.billingList.query.order = this.copyObject(newOrder);
		} else if (newState.shop.ORDER_BY) {
			newState.billingList.query.order = this.copyObject(newState.shop.ORDER_BY);
		}	
		if (!this.isEmpty(this.state.shop.SHOP_ID)) {
			newState.billingList.query.search = { Attribute: 'SHOP_ID', Operator: '=', LongValue: this.state.shop.SHOP_ID };
		}
		this.setState(newState);
	}
	
	onSelectAll(checked) {
		if (this.state.readyToBill) {
			var readyToBill = this.copyObject(this.state.readyToBill);
			Object.keys(readyToBill).forEach(function(key) {
				if (readyToBill[key] !== 'T') {
					readyToBill[key] = checked ? 'Y' : null;
				}
			});
			this.mergeState({ readyToBill: readyToBill });
		}
	}
	
	onSave(transfer) {
		var self = this;
		
		if (transfer) {
			this.showOKCancel('Confirm Transfer', 'Are you sure you want to transfer the checked transactions? ' +
				'You will not be able to make any changes after transfer.', (okClicked) => {
				if (okClicked) {
					self.updateBilling(transfer);
				}
			});
		} else {
			this.updateBilling(transfer);
		}
	}
		
	updateBilling(transfer) {
		var self = this;
		
		// collect ready to bill entries that are not 'T'
		// use 'N' instead of null so there is no confusion going through MVC
		var readyToBill = {};
		Object.keys(this.state.readyToBill).forEach(function(key) {
			if (self.state.readyToBill[key] !== 'T') {
				readyToBill[key] = self.state.readyToBill[key] === 'Y' ? 'Y' : 'N';
			}
		});
		
		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Jobtrack/UpdateBilling',
			overlay: true,
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				readytobill: readyToBill,
				transfer: transfer
			}
		}).done(function (data) {			
			if (data.Success) {
				self.props.parent.showConfirmation(() => {
					return (<>
						{data.Message} Return to <Link to={'/Jobtrack/Billing'}>Billing</Link>.
					</>);
				});				
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}

	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
							Transfer Data for Billing Cycle
						</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<ChemEdit parent={this} user={this.props.user} columns={shopColumns} data={this.state.shop}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey} />					
					  </Col>
					</Row>
					<Row>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={9}>
						<Button id="transfer" variant="warning" type="button" className="float-end" onClick={() => this.onSave(true)}>Transfer</Button>
						<Button style={{ marginRight: '10px' }} id="save" variant="warning" type="button" className="float-end" onClick={() => this.onSave(false)}>Save</Button>
						<Button style={{ marginRight: '10px' }} id="unselect" variant="warning" type="button" className="float-end" onClick={() => this.onSelectAll(false)}>Unselect All</Button>
						<Button style={{ marginRight: '10px' }} id="select" variant="warning" type="button" className="float-end" onClick={() => this.onSelectAll(true)}>Select All</Button>
						<Button style={{ marginRight: '10px' }} id="view" variant="warning" type="button" className="float-end" onClick={() => this.onSubmit()}>View</Button>
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Jobtrack_Billing' table={this.state.billingList}
				    order={this.state.shop.ORDER_BY} onTableSort={(newOrder) => this.onSubmit(newOrder)}
				    onResult={(data) => this.onSearchResult(data)} paging={false} />				
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const shopColumns = [
	{ Header: 'Shop', accessor: 'SHOP_ID', type: 'select', required: true,
		options: { value: 'SHOP_ID', label: 'SHOP_NAME', entity: 'RECHARGES.BILLING_SHOP_SELECT_VW' }}
];

const billingList = {
	query: { entity: 'RECHARGES.JOB_BILLING_VW' },
	columns: [
		{ Header: '', accessor: 'LINE_ID', show: false },
		{ Header: 'Job ID', accessor: 'JOB_ID', width: 70,
			Cell: props => <Link to={'/Jobtrack/Jobs/' + props.value}>{props.value}</Link> },
		{ Header: 'Job Description', accessor: 'JOB_REF', width: 300 },
		{ Header: 'Shop', accessor: 'SHOP_NAME', width: 90 },
		{ Header: 'Date', accessor: 'JOB_DATE', width: 100,
			Cell: props => props.parent.dateToString(props.value) },
		{ Header: 'Labor', accessor: 'LABOR_TIME', width: 70 },
		{ Header: 'Employee', accessor: 'EMPLOYEE', width: 200 },
		{ Header: 'Material', accessor: 'PART_NAME', width: 200 },
		{ Header: 'Cost', accessor: 'PART_COST', width: 70 },
		{ Header: 'PI', accessor: 'PI_NAME', width: 200 },
		{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 110 },
		{ Header: 'Status', accessor: 'LINE_TRANS', width: 325,
			Cell: props => {
				var readyToBill = props.parent.getReadyToBill(props.row.values.LINE_ID);
				return (readyToBill === 'T' ?
					<>Transferred {props.value}</> :
					<ADACheckbox checked={readyToBill === 'Y'}
						onClick={(event) => props.parent.setReadyToBill(props.row.values.LINE_ID, event.target.checked ? 'Y' : null)} />);
			}
		}
	]
};

export default withRouter(Billing);
